import React, { Component } from 'react'
import { connect } from 'react-redux'
import Header from '../header/header'
import PropTypes from 'prop-types';
import { homeColor } from '../../JS/colorConfig'
import { setWebViewAfterKeyBoard } from "../../../JS/setWebView"
import $ from 'jquery'
import {
    setRegPage, setLoadingMass, setGuestLogin,
    validateGuestdetail, popupOpenClose,
    setDeviceLoginPage, currentWidget, setDeviceConfigFailed, setPreloadScreen
} from '../../../action/action'
import { fetchSessionToken } from '../../../JS/fetchSessionToken'
import { setCustomTextForLoginPopup, setGoHome, setLoader, setRedirectInfo } from '../../action/homeAction'
import { LOGINENABLED, PRIVACYPOLICY, TERMSANDCONDITIONS, errorCodeOtpValidationForLogin, globalIV, globalSalt, mapOtpFaliureCodeToMessage } from '../../../config/constant';
import { AesUtil } from '../../../JS/AesUtil';
import { inAppBrowser } from '../../JS/inAppBrowser';
import { withTranslation } from "react-i18next";
import SelectLanguageDropdown from '../../UI/selectLanguageDropdown';
import { sendAnalytics } from '../../../action/homeAction';
import OTPInput from 'react-otp-input'
import { setMakeUserLoginViaFindReservation } from '../../action/action';
import OtpInputBox from '../utils/otpInputBox';
import { getDefaultAnalyticsLabel } from '../../JS/utility';
 
class GuestLoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roomNo: "",
            GuestName: null,
            reservationNo: null,
            status: false,
            error: false,
            errorMsg: null,
            deviceError: false,
            deviceErrorMsg: null,
            submitClick: true,
            guestLoginDetail: {},
            cancelLogin: false,
            loginInProgress: false,
            showLanguageDropdown: false,
            hasReservationNumberCheck: 'false',
            showGuestList: false,
            guestList: [],
            selectedGuest: undefined,
            otpMessage: "",
            showOtpInputPage: false,
            accessCode: "",
            otpValidationErrorCode: "",
            validateOtpButtonClicked:false,
            resendOtpButtonClicked:false
        }
        this.aesUtil = new AesUtil(128, 1000);
    } 
    componentDidMount() {
        if(this.props.allowUserLoginViaFindingReservation){
            this.props.setLoader(true,"Loading...")
            this.onNoClick();
            setTimeout(()=>{
                this.props.setMakeUserLoginViaFindReservation(true);
            },100)
            return;
        }

        homeColor(this.props.menuColor);
        if (!this.props.showPlaceOrder)
            this.props.currentWidget({});

        this.setState({ hasReservationNumberCheck: localStorage.getItem('hasReservationNumberCheck') })
    }

    componentDidUpdate() {
        console.log("$('footer')", $("footer"))
        if (this.props.hideFooter) {
            $("footer").hide()
            $("header").hide()
            $("#place-order-my-order").hide()
        }
    }

    componentWillUnmount() {
        console.log("this.props.showPlaceOrder", this.props.showPlaceOrder)
        if (this.props.showPlaceOrder) {
            window.location.hash = "/hcommerce2"
            //    window.location.href = window.location.hash
        }
        if (this.props.hideFooter) {
            $("footer").show()
            $("header").show()
            $("#place-order-my-order").show()
        }
    }

    showSubmitErrorPopup = (message) => {
        this.props.popupOpenClose(true, message);
        this.setState({ submitClick: true })
    }

    handleSubmit = (event) => {
        console.log("on submit", event);
        event && event.preventDefault();
        //alert("on submit");

        let encodData = fetchSessionToken();
        let guestName = this.state.GuestName
        let roomNumber = this.state.roomNo//event.target.roomNo.value || srcElement.roomNo.value || 
        let reservation_no = this.state.hasReservationNumberCheck == 'true' ? this.state.reservationNo : 'dummy when not required'

        if (this.state.error) {
            this.setState({ error: false });
        }

        if (!guestName && roomNumber && reservation_no) {
            this.showSubmitErrorPopup(this.props.t('login.name-err-msg'));
            return;
        }
        if (!roomNumber && guestName && reservation_no) {
            this.showSubmitErrorPopup(this.props.t('login.roomno-err-msg'));
            return;
        }

        if (!reservation_no && guestName && roomNumber) {
            this.showSubmitErrorPopup(this.props.t('login.reserveno-err-msg'));
            return;
        }

        if (!reservation_no && !guestName && roomNumber) {
            this.showSubmitErrorPopup(this.props.t('login.reserveno-guest-err-msg'));
            return;
        }

        if (!guestName && !roomNumber && reservation_no) {
            this.showSubmitErrorPopup(this.props.t('login.name-roomno-err-msg'));
            return;
        }
        if (!roomNumber && guestName && !reservation_no) {
            this.showSubmitErrorPopup(this.props.t('login.roomno-reserve-err-msg'));
            return;
        }

        let userCanlogin
        if (this.state.hasReservationNumberCheck === 'true') {
            userCanlogin = guestName && roomNumber && reservation_no
        } else {
            userCanlogin = guestName && roomNumber
        }

        if (userCanlogin) {
            this.props.setLoadingMass(true);
            this.props.setPreloadScreen(true);
            this.setState({ loginInProgress: true });

            let isAccompanyLogin = {};
            let otpValidationConfigs = {};

            if (this.props.accompanyGuestFlowEnabled) {
                if (this.state.selectedGuest == "master") {
                    isAccompanyLogin = {
                        guestNotVerified: false
                    }

                    if (this.props.loginToRoomOtpRequiredFlag && !this.props.externalSignIn.memberId) {
                        otpValidationConfigs = {
                            requestForOtp: !this.state.accessCode ? true : false,
                            // requestForOtpError: this.state.showOtpInputPage && ["OTP_MISMATCH", "OTP_EXPIRED"].includes(this.state.otpValidationErrorCode) ? true : undefined,
                            accessCode: this.state.accessCode,
                        }
                    }
                } else {
                    isAccompanyLogin = {
                        guestNotVerified: !this.state.selectedGuest ? true : false,
                        guestId: this.state.selectedGuest
                    }

                    otpValidationConfigs = {
                        requestForOtp: !this.state.accessCode ? true : false,
                        accessCode: this.state.accessCode,
                    }
                }
            } else {
                if (this.props.loginToRoomOtpRequiredFlag && !this.props.externalSignIn.memberId) {
                    otpValidationConfigs = {
                        requestForOtp: !this.state.accessCode ? true : false,
                        // requestForOtpError: this.state.showOtpInputPage && ["OTP_MISMATCH", "OTP_EXPIRED"].includes(this.state.otpValidationErrorCode) ? true : undefined,
                        accessCode: this.state.accessCode,
                    }
                }
            }

            this.setState({ otpValidationErrorCode: ""})

            if (this.state.hasReservationNumberCheck) {
                this.props.validateGuestdetail(encodData, guestName, roomNumber, this.callBackFunc, reservation_no, otpValidationConfigs, isAccompanyLogin);
            } else {
                this.props.validateGuestdetail(encodData, guestName, roomNumber, this.callBackFunc, null, otpValidationConfigs, isAccompanyLogin);
            }

        } else {
            console.log("complete session flow first");
            this.showSubmitErrorPopup(this.state.hasReservationNumberCheck == 'true' ?
                this.props.t('login.name-roomno-reservation-err-msg')
                : this.props.t('login.name-roomno-err-msg'));
        }
    }

    handleRadioChange = (guestId) => {
        this.setState({
            selectedGuest: guestId,
        });
    }

    handleAccompanyGuestSelectionBack = () => {
        this.setState({ showGuestList: false, selectedGuest: undefined, guestList: [] })
    }

    handleOTPScreenBack = () => {
        this.setState({showOtpInputPage: false, accessCode: null, validateOtpButtonClicked:false, resendOtpButtonClicked: false,  errorMsg: "",
            showOtpInputPage: false,
            otpValidationErrorCode: "",});
    }

    callBackFunc = (status, room, locationId, msg, response) => {
        this.setState({ submitClick: true , validateOtpButtonClicked:false, resendOtpButtonClicked: false, errorMsg:""})
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
        if (status) {
            this.props.setPreloadScreen(true);
            let rervationNO = localStorage.getItem("reservationNo");
            this.props.setLoadingMass(false);
            sessionStorage.setItem("redirectInfo", JSON.stringify(this.props.redirectInfo))
            localStorage.setItem("room", room);
            if (this.props.guestLoginPage) {
                this.props.setDeviceLoginPage(false);
            }

            this.props.sendAnalytics(
                this.props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - success",
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );
            
            window.location.reload();
            if (window.FirebasePlugin) {
                window.FirebasePlugin.setCrashlyticsCustomKey('room', room);
            }
        } else {
            this.props.setLoadingMass(false);
            this.setState({ loginInProgress: false })

            if (response.data && response.data.payload && !response.data.payload.linkStatus && errorCodeOtpValidationForLogin.includes(response.data.payload.failureCode)) {

                if (response.status == 503) {
                    //For handling case like "Could not send otp , as no phone/email exist"
                    this.props.popupOpenClose(true, response.data.payload.failureReason);
                }
                else if (response.data.payload.failureCode == "OTP") {
                    // For handling case of "First time error has come so show otp form to user"
                    this.setState({ showOtpInputPage: true })
                    this.setState({ otpMessage: response.data.payload.failureReason })
                }
                else {
                    // For handling case of "either invalid otp, expire otp, mismatch", so just show error inside otp form only
                    this.setState({ errorMsg: mapOtpFaliureCodeToMessage[response.data.payload.failureCode], otpValidationErrorCode: response.data.payload.failureCode })
                    if(response.data.payload.failureCode=="OTP_EXPIRED") {setTimeout(()=>{this.requestOTP();},3000)}
                }

                if (response.data.payload.failureReason) this.setState({ otpMessage: response.data.payload.failureReason });

            }
            else if (response.data && response.data.payload && !response.data.payload.linkStatus && response.data.payload.failureReason == "Multiple Guest") {
                let guestList = response.data.payload.guestList.map(item => {
                    if (item.id == null) {
                        item.id = "master";
                    }
                    return item;
                });
                this.setState({ guestList: guestList }, () => this.setState({showGuestList: true}));
            }
            else if (this.state.hasReservationNumberCheck == 'true') {

                this.props.popupOpenClose(true, this.props.t('login.cant-find-name-room-res'));
            } else {
                this.props.popupOpenClose(true, this.props.t('login.cant-find-name-room'));
            }
            this.props.setPreloadScreen(false);

            this.props.sendAnalytics(
                this.props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - failed",
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );

        }
    }
    onNoClick = () => {
        if (this.state.loginInProgress) {
            return;
        }
        window.localStorage.removeItem("room");
        this.props.setRedirectInfo({})
        this.props.setCustomTextForLoginPopup({})
        if (this.props.guestLoginPage) {
            this.props.setDeviceLoginPage(true);
            if (this.props.currentWidget && this.props.currentWidget.widgetType) {
                window.history.back();
            } else {
                document.location.reload();
            }

        } else {
            setTimeout(() => {
                this.props.setRegPage(false);
            }, 10);
            this.props.setGuestLogin(false);
            if (!this.props.showPlaceOrder && this.props.currentHomePage.uniqueKey !== 'notifications')
                this.props.setGoHome(true);
        }
    }
    handleCHange = (event, field) => {
        if (field === "roomNo") {
            this.setState({ roomNo: event.target.value, error: false });
        } else if (field === "reservationNo") {
            this.setState({ reservationNo: event.target.value, error: false });
        } else {
            this.setState({ GuestName: event.target.value, error: false });
        }
    }

    handleInputFocus = () => {
        $('#login-window').addClass("login-window-input-focused")
    }

    blurWithSubmit = (event) => {
        console.log("blurWithSubmit", event.relatedTarget);
        event.preventDefault();
        document.body.scrollTop = 0;
        window.scrollTo(0, 0);

        $('#login-window').removeClass("login-window-input-focused")
    }

    submitKeyEvent = (event) => {
        if (event.keyCode === 13) {
            console.log("keycode", event.keyCode);
            if (this.state.submitClick) {
                this.setState({ submitClick: false })
                this.handleSubmit(event);
            }
            event.preventDefault();
        }
    }

    submitAfterBlur = (event) => {
        if (!navigator.onLine) {
            this.props.setRegPage(false);
            this.props.setDeviceConfigFailed(true);
            return;
        }
        if (this.state.loginInProgress) {
            return;
        }
        console.log("called")
        event && event.preventDefault();
        if (this.state.submitClick) {
            // this.setState({ submitClick: false })
            this.handleSubmit(event);
        }
    }

    openLinkHandler = (link, displayName) => {

        if (link) {
            inAppBrowser(link, this.props, false, { displayName: displayName, dontSetCurrentWidget: true })
        }

    }

    requestOTP = (event) => {
        
        this.setState({accessCode: null ,
            otpValidationErrorCode: ""}, () => {
            this.submitAfterBlur(event);
        });
         
    }

    render() {
        let fontColor = this.props.menuColor && this.props.menuColor.assetFontColor ?
            this.props.menuColor.assetFontColor : "";
        const { t } = this.props
        return (
            <div>
                <Header
                    PageNameFromParent={t('login.heading')}
                    GreetingFromParent={t('login.heading_txt')}
                    hideProfilePhoto={true}
                    header_class={"loginPage"}
                    showBackgroundImage={true}
                />
                <section id="landingPage" class="widgets loginPage">
                    <div class={`widgets user-info ${this.props.langWidget && 'lang-toggle'}`}>
                        {this.props.langWidget ?
                            <div class="tile-lg tile-container" style={{ minHeight: 'auto' }}>
                                <div class="w-100 form-row padding-left-0 padding-right-0 margin-bottom-2 align-left">
                                    <SelectLanguageDropdown />
                                </div>
                            </div>
                            : <></>
                        }
                        <div id='login-window' class="tile-lg tile-container">

                            {
                                this.state.showOtpInputPage ? (
                                
                                
                                    <section class="overlay-custom" >
                                    <div class="overlay-window-container-custom custom-popup" id="guestLoginOTP" >
                                        <div class="overlay-window-custom" >
                                            <div class="overlay-content padding-0">
                                                <div class="overlay-header">
                                                    <div class="overlay-header-title"  >
                                                         <p>{t('login.otp_validation.heading')}</p>          
                                                    </div>
                                                     <div class="close-button"   onClick={this.handleOTPScreenBack}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <path d="M15 5L5 15M5 5L15 15" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </div>
                                                    
                                                </div>
                                                
                                                <div class="overlay-body-custom">
                                                 <p class="heading" >{this.state.otpMessage}</p> 
                
                                                                
                                                    <OtpInputBox htmlId={"unique-otp-input"} value={this.state.accessCode} onChange={(value)=>{this.setState({ accessCode: value })}} allowAutoFill={true} maxlength={this.props.loginToRoomOtpLength}/>
                                                     
                
                                                        {this.state.errorMsg && <div class="error-msg" style={{ color: "red" }}>{this.state.errorMsg}</div>}
                
                                                    
                                                </div>
                                                <div class="overlay-controls-custom" >
                                                       <p class="subHeading">{t('login.otp_validation.didnt_receive_heading')}</p>
                                                      <button class={`button  primary `} disabled={this.state.validateOtpButtonClicked} onClick={(event)=>{ this.setState({validateOtpButtonClicked:true}); this.submitAfterBlur(event);}} > { this.state.validateOtpButtonClicked && <><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div></>} {t('login.otp_validation.validate_otp_button')}</button>
                                                      
                                                      <button class="button secondary custom-popup-underline" disabled={this.state.resendOtpButtonClicked} onClick={(event)=> { this.setState({resendOtpButtonClicked:true, errorMsg:t('login.otp_validation.sending_new_otp_error_msg')}); this.requestOTP(event)} }>  Resend </button> 
                                                      
                                                    {/* onClick={props.customPopupConfigs.secondaryOnClick}>{props.customPopupConfigs.secondaryButtonText}</button>} */}
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                 
                        </section> )
                                    :
                                    this.state.showGuestList ? (
                                        <div className="overlay-window">
                                            <div className="overlay-controls">
                                                <div className="form-row margin-top-1 align-left">
                                                    <label>{t('login.guest_list')}</label>
                                                    <div className="radio-group">
                                                        {this.state.guestList.map((guest, index) => (
                                                            <div className="optgroup" key={index}>
                                                                <input
                                                                    type="radio"
                                                                    name="companion"
                                                                    id={`companion-${guest.id}`}
                                                                    checked={this.state.selectedGuest === guest.id} // check if the guest is selected
                                                                    onChange={() => this.handleRadioChange(guest.id)}
                                                                />
                                                                <label htmlFor={`companion-${guest.id}`}>
                                                                    {guest.firstName} {guest.lastName}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <button className="button w-100 margin-top-1 secondary"
                                                    onClick={this.submitAfterBlur}>Proceed</button>
                                                <button
                                                    className="button w-100 margin-top-1 secondary"
                                                    onClick={this.handleAccompanyGuestSelectionBack}
                                                >
                                                    Back
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    :

                                    <div class="content">
                                        <form id='submitGuestLogin'>

                                            <div class="label">
                                                <p class="heading"
                                                    style={fontColor ?
                                                        { color: `${fontColor}` }
                                                        : { color: "inherit" }
                                                    }
                                                >{this.props.customTextForLoginPopup.topHeading || t('login.Login')}
                                                    <span onClick={this.onNoClick}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <path d="M15 5L5 15M5 5L15 15" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                </p>
                                                <div class="row login-disc">
                                                    <p class="margin-bottom-0">{this.props.customTextForLoginPopup.warning || t('login.warning')}</p>
                                                </div>
                                                {this.props.customTextForLoginPopup.heading && <div>
                                                    <div class="overlay-body-heading" style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        marginBottom: "40px",
                                                        alignSelf: 'stretch'
                                                    }}>
                                                        <p class="heading" >{this.props.customTextForLoginPopup.heading}</p>
                                                        {this.props.customTextForLoginPopup.subHeading && <p class="subHeading">{this.props.customTextForLoginPopup.subHeading}</p>}
                                                    </div>
                                                </div>}
                                                <div class="form-controls">
                                                    <div class="form-row">
                                                        <label style={fontColor ?
                                                            { color: `${fontColor}` }
                                                            : { color: "inherit" }
                                                        }
                                                            for="lastName">{t('login.last_name')}</label>
                                                        <input
                                                            id="InputForguestName2"
                                                            type="input"
                                                            name="lastName"
                                                            autoComplete='family-name'
                                                            placeholder=""
                                                            minlength="3"
                                                            maxlength="50"
                                                            onKeyDown={this.submitKeyEvent}
                                                            onChange={(event) => { this.handleCHange(event, "guestName") }}
                                                            value={this.state.GuestName}
                                                            onFocus={() => this.handleInputFocus()}
                                                            onBlur={(event) => { this.blurWithSubmit(event) }}
                                                            required
                                                        />
                                                    </div>
                                                    <div class="form-row">
                                                        <label style={fontColor ?
                                                            { color: `${fontColor}` }
                                                            : { color: "inherit" }
                                                        }
                                                            for="roomNumber">{t('login.room_no')}</label>
                                                        <input
                                                            id="InputForroomNo2"
                                                            type="input"
                                                            name="roomNo"
                                                            value={this.state.roomNo}
                                                            placeholder=""
                                                            minlength="2"
                                                            maxlength="15"
                                                            onKeyDown={this.submitKeyEvent}
                                                            onChange={(event) => { this.handleCHange(event, "roomNo") }}
                                                            onFocus={() => this.handleInputFocus()}
                                                            onBlur={(event) => { this.blurWithSubmit(event) }}
                                                            required
                                                        />
                                                    </div>

                                                    {this.state.hasReservationNumberCheck === 'true' &&
                                                        <div class="form-row">
                                                            <label style={fontColor ?
                                                                { color: `${fontColor}` }
                                                                : { color: "inherit" }
                                                            }
                                                                for="roomNumber">{t('login.reservation_no')}</label>
                                                            <input
                                                                id="InputForroomNo"
                                                                type="input"
                                                                name="reservationNo"
                                                                value={this.state.reservationNo}
                                                                placeholder=""
                                                                minlength="2"
                                                                maxlength="15"
                                                                onKeyDown={this.submitKeyEvent}
                                                                onChange={(event) => { this.handleCHange(event, "reservationNo") }}
                                                                onFocus={() => this.handleInputFocus()}
                                                                onBlur={(event) => { this.blurWithSubmit(event) }}
                                                                required
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div class="controls">
                                                <a class="button" style={{
                                                    opacity: this.state.loginInProgress ? "0.5" : "1"
                                                }} onClick={this.submitAfterBlur} id="guestDevRegNext">{this.state.loginInProgress && <div class="loader-ring"><img src="layout_2/assests/loader.png" /></div>} {this.props.customTextForLoginPopup.primaryButtonText || t('login.connect_btn')}</a>
                                                <a class="button secondary margin-top-1" style={{
                                                    opacity: this.state.loginInProgress ? "0.5" : "1"
                                                }} onClick={this.onNoClick}>{t('login.cancel_btn')}</a>
                                            </div>
                                            <div class="overlay-controls padding-0">
                                                <div class="privacy">
                                                    {this.props.privacyPolicyUrl && <p style={{ fontWeight: "normal", fontSize: "14px" }} className="w-50 align-left" onClick={() => this.openLinkHandler(this.props.privacyPolicyUrl, "Privacy Policy")}>Privacy Policy</p>}
                                                    {this.props.tncUrl && <p style={{ fontWeight: "normal", fontSize: "14px" }} className="w-50 align-right" onClick={() => this.openLinkHandler(this.props.tncUrl, "Terms & Conditions")}>Terms & Conditions</p>}
                                                </div>
                                                <div class="row app-version">
                                                    <p class="margin-bottom-0" style={{ fontSize: '0.8rem' }}>{`V${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`}</p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                            }
                        </div>
                    </div>
                </section>
                {
                    !LOGINENABLED && <section class="overlay">
                        <div class="overlay-window-container">
                            <div class="overlay-window">
                                <div class="overlay-content padding-0">
                                    <div class="overlay-header">
                                        <div class="overlay-header-title w-65">
                                            <h2 style={{ color: "#000" }}>Coming Soon</h2>
                                            <p>Guest login feature will be available soon.</p>
                                        </div>
                                        <div class="overlay-header-icon w-35">
                                            <i class="fas fa-user"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="overlay-controls">
                                    <button class="button w-100" onClick={() => this.props.setRegPage(false)}>Close</button>
                                </div>
                                <div class="row form-row padding-left-1 padding-right-1">
                                    <div class="col-2">
                                        <p style={{ fontWeight: "normal", fontSize: "14px" }} className="w-50 align-left" onClick={() => this.openLinkHandler(PRIVACYPOLICY)}>Privacy Policy</p>
                                        {TERMSANDCONDITIONS && <p style={{ fontWeight: "normal", fontSize: "14px" }} className="w-50 align-right" onClick={() => this.openLinkHandler(TERMSANDCONDITIONS)}>Terms & Conditions</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor ? state.store.home.MenuColor : {},
        guestLoginPage: state.store.guestLoginPage,
        currentWidget: state.store.sideNavBar.currentWidget,
        privacyPolicyUrl: state.store.home.privacyPolicyUrl,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        langWidget: state.store.home.langWidget,
        tncUrl: state.store.home.tncUrl,
        redirectInfo: state.store2.redirectInfo,
        currentHomePage: state.store2.currentHomePage,
        showPlaceOrder: state.store2.showPlaceOrder,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        footerTabList: getTabs(state.store.home.currentDuration),
        customTextForLoginPopup: state.store.customTextForLoginPopup,
        loginToRoomOtpRequiredFlag: state.store.home.clientConfig.loginToRoomOtpRequiredFlag,
        accompanyGuestFlowEnabled: state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.accompanyGuestFlowEnabled,
        loginToRoomOtpLength: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.loginToRoomOtpLength ,
        externalSignIn: state.store2.externalSignIn,
        allowUserLoginViaFindingReservation: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.allowUserLoginViaFindingReservation,
        guestDetail: state.store.home.guestDetails,
    }
}

const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}

export default connect(
    mapStateToProps,
    {
        setRegPage,
        setLoadingMass,
        validateGuestdetail,
        popupOpenClose,
        setDeviceLoginPage,
        currentWidget,
        setRedirectInfo,
        setGoHome,
        setGuestLogin,
        setDeviceConfigFailed,
        setPreloadScreen,
        sendAnalytics,
        setCustomTextForLoginPopup,
        setMakeUserLoginViaFindReservation,
        setLoader
    }
)(withTranslation('translations')(GuestLoginPage));


{/* <input 
id="unique-otp-input"
value={this.state.accessCode}
onChange={event =>{ if(String(event.target.value).length > this.props.loginToRoomOtpLength) return;  this.setState({ accessCode: event.target.value })}}
// max={this.props.loginToRoomOtpLength}
// maxLength={this.props.loginToRoomOtpLength}
type='number'
autoComplete='one-time-code'
/> */}